import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import { flatpickrConfig } from '../../../config';

export default {
    name: 'issuedLetterDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            issuedLetters: [],
            search: {
                dateRange: '',
                fromDate: '',
                toDate: '',
                keywords: []
            },
            flatpickrConfig,
            skip: 0,
            take: 5,
        }
    },
    methods: {
        initialize() {
            let vm = this;

            return vm.getIssuedLetters()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.issuedLetters = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },

        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getIssuedLetters()
                .then(function (res) {
                    vm.issuedLetters = vm.issuedLetters.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            let datesArr = vm.search.dateRange.trim().split('to')
            if (datesArr.length > 1) {
                vm.search.fromDate = datesArr[0].trim();
                vm.search.toDate = datesArr[1].trim();
            }
            vm.getIssuedLetters()
                .then(function (res) {
                    vm.issuedLetters = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getIssuedLetters() {
            let vm = this;
            return axiosCommon.get(`o/issuedLetters?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&fromDate=${vm.search.fromDate.toString()}&toDate=${vm.search.toDate}&keywords=${vm.search.keywords}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/issue-letter-dashboard/issue-letter-dashboard.js